import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import NewsHero from './components/NewsHero';
import ExpansionTimeline from './components/ExpansionTimeline';

export default function NewsPage() {
  return (
    <div className="relative">
      <Navbar />
      <main>
        <NewsHero />
        <ExpansionTimeline />
      </main>
      <Footer />
    </div>
  );
}